import React from 'react';
import TextFieldComponent from 'components/library/TextField';
import MaterialUiField from '../MaterialUiField';

const TextField = props => (
  <MaterialUiField  defaultValue="" {...props} muiComponent={TextFieldComponent} type="text" />
);

export default TextField;
